export const ADD_TO_TRIPBOARD = 'ADD_TO_TRIPBOARD';
export const ADD_TO_BOARD = 'ADD_TO_BOARD';
export const CREATE_BOARD = 'CREATE_BOARD';
export const CREATE_TRIPBOARD = 'CREATE_TRIPBOARD';
export const CREATE_TRIPBOARD_ERROR = 'CREATE_TRIPBOARD_ERROR';
export const CREATE_TRIPBOARD_SUCCESS = 'CREATE_TRIPBOARD_SUCCESS';
export const REMOVE_FROM_TRIPBOARD = 'REMOVE_FROM_TRIPBOARD';
export const SET_TRIPBOARD_STATE = 'SET_TRIPBOARD_STATE';
export const GET_TRIPBOARD_PREVIEWS = 'GET_TRIPBOARD_PREVIEWS';
export const GET_TRIPBOARD_PREVIEWS_ERROR = 'GET_TRIPBOARD_PREVIEWS_ERROR';
export const LOADING_TRIPBOARD_PREVIEWS = 'LOADING_TRIPBOARD_PREVIEWS';
export const SET_TRIPBOARD_TRANSLATIONS = 'SET_TRIPBOARD_TRANSLATIONS';
export const MAX_TRIPBOARD_NAME_LENGTH = 25;
export const NEW_MODAL = 'ha_pulse_tripboard_new_modal_test';
export const LOADING_ANIMATION = 'ha_pulse_tripboard_loading_animation_test';
export const SET_HAV = 'TRIPBOARDS_SET_HAV';
